import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MoverGroupRbacRoleEntity } from './mover-group-rbac-role.entity';
import { MoverEntity } from './mover.entity';

@Entity('_mover_group')
export class MoverGroupEntity extends BaseEntity {
	@Column('varchar', { name: '_label', length: 64 })
	public label!: string;

	@Column('varchar', { name: '_key', length: 64 })
	public key!: string;

	@Column('varchar', { name: '_icon', nullable: true, length: 64 })
	public icon!: string | null;

	@OneToMany(() => MoverEntity, (mover) => mover.fkMoverGroup, {})
	public movers!: Array<MoverEntity>;

	@OneToMany(
		() => MoverGroupRbacRoleEntity,
		(moverGroupRbacRole) => moverGroupRbacRole.fkMoverGroup,
		{},
	)
	public moverGroupRbacRoles!: Array<MoverGroupRbacRoleEntity>;
}
